import capitalize from 'lodash/capitalize'
elm = require('../../../elm/elm.js')

$ ->
  setUpPickers = () ->
    if $('.icon-picker').length > 0
      transformName = (name) ->
        name.split(' ').map(capitalize).join(' ')

      $('.icon-picker').each ->
        if ($(this).data('icon-picker-widget-init'))
          return

        $(this).data('icon-picker-widget-init', true)

        selectNode = this
        $(this).hide()
        id = $(this).attr('id')
        node = $('<div class="icon-picker-container"></div>').insertAfter($(this)).get(0)

        selected = null
        options = $(this).find('option').map((_, opt) ->
          optClass = $(opt).attr('value')
          optName = transformName($(opt).text())
          if !!$(opt).attr('selected')
            selected = optClass

          { class: optClass, displayName: optName }
        ).toArray()

        flags = { selected: selected, icons: options }
        app = elm.IconPickerWidget.embed(node, flags)

        app.ports.portSelectIcon.subscribe (val) ->
          $(selectNode).val(val)

  setUpPickers()

  if $('.perks').length > 0
    $('.perks').on('cocoon:after-insert', setUpPickers)
